import { render, staticRenderFns } from "./RoleCard.Create.vue?vue&type=template&id=ba1ee91c&scoped=true&"
import script from "./RoleCard.Create.vue?vue&type=script&lang=js&"
export * from "./RoleCard.Create.vue?vue&type=script&lang=js&"
import style0 from "./RoleCard.Create.vue?vue&type=style&index=0&id=ba1ee91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1ee91c",
  null
  
)

export default component.exports